import { mapKeysDeep, transformKey } from '@td/utils';

import {
  FETCH_PRESCRIBER,
  FETCH_PRESCRIBER_SUCCESS,
  FETCH_PRESCRIBER_FAILURE,
  UPDATE_PRESCRIBER,
  UPDATE_PRESCRIBER_SUCCESS,
  UPDATE_PRESCRIBER_FAILURE,
  REFRESH_PRESCRIBER,
  REFRESH_PRESCRIBER_SUCCESS,
  REFRESH_PRESCRIBER_FAILURE,
  REACTIVATE_PRESCRIBER,
  DEACTIVATE_PRESCRIBER,
  DEACTIVATE_PRESCRIBER_FAILURE,
  REACTIVATE_PRESCRIBER_SUCCESS,
  DEACTIVATE_PRESCRIBER_SUCCESS,
  REACTIVATE_PRESCRIBER_FAILURE,
  CREATE_PRESCRIBER,
  CREATE_PRESCRIBER_SUCCESS,
  CREATE_PRESCRIBER_FAILURE
} from './actions';

const DEFAULT_STATE = {
  prescriberInfo: {},
  loading:        false,
  fetched:        false,
  errors:         []
};

const extractError = (action) => {
  return action.errors ||
         (action.payload.data && action.payload.data.errors) ||
         (action && action.payload && action.payload[0] && action.payload[0].response &&
          action.payload[0].response.data && action.payload[0].response.data.errors &&
          action.payload[0].response.data.errors.map(err => err.message)
         );
};

export const prescriberReducer = (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case FETCH_PRESCRIBER:
    case UPDATE_PRESCRIBER:
    case REFRESH_PRESCRIBER:
    case DEACTIVATE_PRESCRIBER:
    case REACTIVATE_PRESCRIBER:
    case CREATE_PRESCRIBER: {
      return {
        ...state,
        loading: true,
        fetched: false
      };
    }
    case FETCH_PRESCRIBER_SUCCESS:
    case UPDATE_PRESCRIBER_SUCCESS:
    case REFRESH_PRESCRIBER_SUCCESS:
    case REACTIVATE_PRESCRIBER_SUCCESS:
    case DEACTIVATE_PRESCRIBER_SUCCESS:
    case CREATE_PRESCRIBER_SUCCESS: {
      const responseWithTranslatedKeys = mapKeysDeep(action.payload.data, transformKey);
      return {
        ...state,
        fetched:        true,
        loading:        false,
        prescriberInfo: responseWithTranslatedKeys
      };
    }
    case FETCH_PRESCRIBER_FAILURE:
    case UPDATE_PRESCRIBER_FAILURE:
    case REFRESH_PRESCRIBER_FAILURE:
    case REACTIVATE_PRESCRIBER_FAILURE:
    case DEACTIVATE_PRESCRIBER_FAILURE:
    case CREATE_PRESCRIBER_FAILURE: {
      return {
        ...state,
        loading: false,
        errors: extractError(action)
      };
    }
    default: {
      return state;
    }
  }
};
